import { ActionTree } from 'vuex';
import RootState from '@/store/root_state';
import { CourseState } from './state';
import { UserModel, CourseModel } from '@descomplica/dex-models';

const actions: ActionTree<CourseState, RootState> = {
  async SWITCH_CURRENT_COURSE(
    { commit, dispatch, getters },
    { course, user }: { course: CourseModel; user: UserModel },
  ) {
    const isPostgradCourse = getters.isPostgraduateCourse;
    if (isPostgradCourse) {
      await dispatch('GET_POSTGRAD_STUDY_PLANNING_FEATURE_AVAILABILITY_FOR_COURSE', course.id);
    }

    commit('SWITCH_CHIMERA_CURRENT_COURSE', course.descomplicaCourseId);

    const classroomsByCourseId = user.getClassroomsByCourseId(course.id);
    if (!classroomsByCourseId.length) {
      await dispatch('PULL_COURSE_INFO', { course });
    }
  },

  async PULL_COURSE_INFO({ dispatch }, { course }: { course: CourseModel }) {
    await dispatch('PULL_USER_ENROLLMENTS', { courseId: course.id });
  },
};

export default actions;
